import { useState } from 'react'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { SubscriptionsScreen } from '@features/subscriptions'
import { SaleDetailDrawer } from '@features/sales'

export function AssinaturasPage() {
  const search = useSearch({ from: '/protected/assinaturas' })
  const navigate = useNavigate()
  const [saleId, setSaleId] = useState<string | null>(null)
  const [subscriptionOriginId, setSubscriptionOriginId] = useState<string | null>(null)

  function openSaleFromSubscription(nextSaleId: string) {
    setSubscriptionOriginId(search.sub ?? null)
    void navigate({ to: '/assinaturas', search: { ...search, sub: undefined } }).then(() => {
      setSaleId(nextSaleId)
    })
  }

  function backToSubscription() {
    const originId = subscriptionOriginId
    setSaleId(null)
    setSubscriptionOriginId(null)
    if (originId) {
      void navigate({ to: '/assinaturas', search: { ...search, sub: originId } })
    }
  }

  return (
    <>
      <SubscriptionsScreen
        dateRange={{
          preset: search.preset ?? 'month',
          from: search.from ?? null,
          to: search.to ?? null,
        }}
        onDateRangeChange={(value) => {
          void navigate({
            to: '/assinaturas',
            search: {
              ...search,
              preset: value.preset,
              from: value.preset === 'custom' ? (value.from ?? undefined) : undefined,
              to: value.preset === 'custom' ? (value.to ?? undefined) : undefined,
            },
            replace: true,
          })
        }}
        selectedId={search.sub ?? null}
        currency={search.currency}
        onCurrencyChange={(currency) => {
          void navigate({ to: '/assinaturas', search: { ...search, currency }, replace: true })
        }}
        onSelect={(subscriptionId) => {
          void navigate({
            to: '/assinaturas',
            search: {
              ...search,
              sub: subscriptionId ?? undefined,
            },
          })
        }}
        onViewSale={openSaleFromSubscription}
      />
      <SaleDetailDrawer
        scope="charge"
        saleId={saleId}
        onClose={() => {
          setSaleId(null)
          setSubscriptionOriginId(null)
        }}
        onBack={subscriptionOriginId ? backToSubscription : undefined}
        backLabel="Voltar para assinatura"
      />
    </>
  )
}
